import { ROUTE_ERROR_TEXT } from '../constants/RouteError.constants';

const key = ROUTE_ERROR_TEXT.chunkLoadError.sessionStorageKey;

/**
 * Removes the "hasReloaded" flag from session storage to allow for future reloads.
 */
export const removeHasReloaded = () => {
  const hasReloaded = sessionStorage.getItem(key);

  if (hasReloaded) {
    sessionStorage.removeItem(key);
  }
};
